import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Truck, Users, Building, Layout, Tag, Briefcase, Wrench, ChevronRight } from "lucide-react";
import Reveal from "../components/Reveal";
import { useLang } from "../contexts/LangContext";
import { PageHeader } from "./Formats";

const ICONS = [Truck, Users, Building, Layout, Tag, Briefcase, Wrench];

export default function Servizi() {
  const { t } = useLang();
  return (
    <div data-testid="servizi-page">
      <PageHeader
        eyebrow={t.services.eyebrow}
        title={t.services.title}
        subtitle={t.organizers.body}
      />

      {/* SERVICES GRID */}
      <section className="bg-[#0a0a0a] pb-24">
        <div className="container-x grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {t.services.items.map((s, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <Reveal key={i} delay={(i % 3) * 80}>
                <div className="premium-card p-8 h-full flex flex-col" data-testid={`servizi-card-${i}`}>
                  <Icon className="w-7 h-7 text-[color:var(--gold)] mb-6" />
                  <div className="font-display text-[10px] tracking-[0.32em] uppercase text-[color:var(--gold)] mb-2">
                    Servizio · {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="h3 text-white mb-3">{s.t}</div>
                  <p className="text-[color:var(--txt-secondary)] leading-relaxed flex-1">{s.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      {/* FOR ORGANIZERS DETAILED */}
      <section className="section-pad bg-[#080808] border-t border-white/5">
        <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10">
          <Reveal className="lg:col-span-5">
            <div className="eyebrow mb-4">{t.organizers.eyebrow}</div>
            <h2 className="h2 text-white">{t.organizers.title}</h2>
            <p className="body-lg mt-6">{t.organizers.body}</p>
            <Link to="/contatti" className="btn-primary mt-10" data-testid="organizers-cta-2">
              {t.common.contactUs} <ArrowRight className="w-4 h-4" />
            </Link>
          </Reveal>
          <Reveal className="lg:col-span-7" delay={150}>
            <div className="border border-white/10 divide-y divide-white/10">
              {t.organizers.bullets.map((b, i) => (
                <div key={i} className="p-6 flex items-center gap-5 group hover:bg-white/[0.02] transition-colors">
                  <span className="font-display tabular-nums text-2xl text-[color:var(--gold)] w-12">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span className="text-white flex-1 text-lg">{b}</span>
                  <ChevronRight className="w-5 h-5 text-white/40 group-hover:text-[color:var(--gold)] transition-colors" />
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      {/* WHY US */}
      <section className="section-pad bg-[#0a0a0a]">
        <div className="container-x">
          <Reveal>
            <div className="eyebrow mb-4">{t.why.eyebrow}</div>
            <h2 className="h2 text-white max-w-3xl">{t.why.title}</h2>
          </Reveal>
          <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
            {t.why.points.map((p, i) => (
              <Reveal key={i} delay={(i % 4) * 80}>
                <div className="border border-white/10 p-7 h-full hover:border-[color:var(--gold)]/60 transition-colors">
                  <div className="font-display text-xs tracking-[0.32em] uppercase text-[color:var(--gold)] mb-3">
                    · {String(i + 1).padStart(2, "0")}
                  </div>
                  <div className="h3 text-white mb-2">{p.t}</div>
                  <p className="text-[color:var(--txt-secondary)] text-sm leading-relaxed">{p.d}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
